/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificationSettingsInput } from '../../models/notification-settings-input';

export interface UpdateNotificationSetting$Params {
  tenantId: string;
  'Active-Tenant-Identifier': string;
  notificationType: 'SMS' | 'PUSH';
      body: NotificationSettingsInput
}

export function updateNotificationSetting(http: HttpClient, rootUrl: string, params: UpdateNotificationSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateNotificationSetting.PATH, 'put');
  if (params) {
    rb.path('tenantId', params.tenantId, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('notificationType', params.notificationType, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateNotificationSetting.PATH = '/tenants/{tenantId}/notification-settings/{notificationType}';
